module.exports = __webpack_public_path__ + "img/logo_AXAKERALTY.b0a91d40.svg";